/**
 * Logger condicional para os componentes de IA do front-end.
 *
 * Espelha o comportamento do DebugLogger PHP:
 * - log/warn/info/debug → só emitem quando window.athenaDebug === true
 * - error              → SEMPRE emite (erros são críticos)
 *
 * A flag `window.athenaDebug` é injetada pelo Blade a partir de APP_DEBUG.
 */

declare global {
    interface Window {
        athenaDebug?: boolean;
    }
}

const isDebug = (): boolean => window.athenaDebug === true;

const aiLogger = {
    log(...args: unknown[]): void {
        if (isDebug()) console.log(...args);
    },
    info(...args: unknown[]): void {
        if (isDebug()) console.info(...args);
    },
    warn(...args: unknown[]): void {
        if (isDebug()) console.warn(...args);
    },
    debug(...args: unknown[]): void {
        if (isDebug()) console.debug(...args);
    },
    error(...args: unknown[]): void {
        // Erros sempre emitem, independente do flag
        console.error(...args);
    },
};

export default aiLogger;
